import { collection, subCollection, type Timestamp } from "@doitintl/models-types";

export type DataConnectorError = {
  message: string | null;
  ts: Timestamp;
};

export enum OnboardingIssueType {
  TableNotFound = "Table Not Found",
  PermissionNotFound = "Permission Not Found",
}

export class BaseDataConnectorModel {
  customerId!: string;

  orgId!: string;

  status!: string;

  timeCreated!: Timestamp;

  lastUpdated!: Timestamp;

  error!: DataConnectorError | null;

  onboardedBy!: string;
}

export type OnboardingIssue = {
  Type: OnboardingIssueType;
  Detail: string;
};

@subCollection("snowflake-configuration")
export class DataConnectorSnowflakeModel extends BaseDataConnectorModel {
  accountId!: string;

  user!: string;

  OnboardingIssues?: OnboardingIssue[];
}

export type DatadogProduct = {
  id: string;
  label: string;
  quantity: number;
  multiplier: string;
  price: number;
  unit: string;
  usageType: string;
};

export type DataDogSubscription = {
  endDate: Timestamp;
  products: DatadogProduct[];
  startDate: Timestamp;
};

@subCollection("datadog-configuration")
export class DataConnectorDatadogModel extends BaseDataConnectorModel {
  site!: string;

  subscriptions!: DataDogSubscription[] | null;
}

@subCollection("openai-configuration")
export class DataConnectorOpenaiModel extends BaseDataConnectorModel {
  orgName!: string;
}

@subCollection("cloudzero-configuration")
export class DataConnectorCloudZeroModel extends BaseDataConnectorModel {
  orgName!: string;
}

@collection("dataConnectors")
export class DataConnectorModel {
  subCollections!: {
    "snowflake-configuration": DataConnectorSnowflakeModel;
    "datadog-configuration": DataConnectorDatadogModel;
    "openai-configuration": DataConnectorOpenaiModel;
    "wiz-configuration": BaseDataConnectorModel;
    "cloudzero-configuration": BaseDataConnectorModel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
}
